export default class PipiPupuAPIClient {
	constructor(apiUrl, auth) {
		this.apiUrl = apiUrl;
		this.auth = auth;
	}

	request(method, resource, query, body, signal) {
		let fetchOptions = {
			method,
			headers: {
				'Content-type': body?.constructor?.name == 'File' ? 'application/octet-stream' : 'application/json',
			},
			signal,
		};
		if(this.auth && this.auth.token && this.auth.token.raw) fetchOptions.headers.authorization = `Bearer ${this.auth.token.raw}`;
		if(method == 'POST' || method == 'PUT' || method == 'PATCH')
			fetchOptions.body = body?.constructor?.name == 'File' ? body : JSON.stringify(body||null);
		const q = query && new URLSearchParams(query).toString();
		const url = `${this.apiUrl}/${resource}${q ? `?${q}` : ''}`;
		return fetch(url, fetchOptions).then(r => {
			return r.text().then(text => {
				if(!text) throw new Error('Empty response');
				let parsed;
				try {
					parsed = JSON.parse(text);
				} catch(e) {
					throw new Error(`${r.status != 200 ? `${r.status} ${r.statusText||''}` : ''}${(text||'').replace(/<[^>]+>/g, '')}`);
				}
				if(parsed?.error) {
					if(parsed.error.startsWith('Could not verify jwt')) {
						localStorage.removeItem('username');
						localStorage.removeItem('authToken');
						this.auth.setToken(null);
					}
					throw new Error(parsed.error);
				}
				if(r.status != 200) throw new Error(text);
				return parsed;
			});
		});
	}

	post(resource, body) {
		return this.request('POST', resource, {}, body);
	}

	put(resource, body) {
		return this.request('PUT', resource, {}, body);
	}

	patch(resource, body) {
		return this.request('PATCH', resource, {}, body);
	}

	get(resource, query, signal) {
		return this.request('GET', resource, query, null, signal);
	}

	delete(resource, query)	{
		return this.request('DELETE', resource, query);
	}

	uploadFile(filename, blob) { return this.request('POST', 'file', {filename}, blob); }
}
